import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/thumbs-up-on.svg'
import _imports_1 from '@/assets/images/thumbs-up-off.svg'


const _withScopeId = n => (_pushScopeId("data-v-4ce3ff30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "heading" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "info color-info mt5" }
const _hoisted_6 = { class: "category" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" カテゴリ： ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success fs12" }, "移動", -1))
const _hoisted_9 = { class: "time" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "mt10 mb10" }
const _hoisted_12 = { class: "filename" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "flexwrap" }
const _hoisted_15 = { class: "wrap" }
const _hoisted_16 = { class: "color-success" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "14",
  height: "14",
  class: "image-position",
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "color-success" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "14",
  height: "14",
  class: "image-position",
  alt: ""
}, null, -1))
const _hoisted_20 = { class: "color-success" }
const _hoisted_21 = {
  key: 0,
  class: "detail-link"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success fs12" }, "別ページで表示する", -1))
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, "編集", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, "削除", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "編集", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-heading" }, "質問", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-heading" }, "解答", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "mt10 send-button" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "sub-heading" }, "コメント", -1))
const _hoisted_34 = { class: "comment-form" }
const _hoisted_35 = { class: "send-button mt10" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("送信")
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "fs12 color-info mb6" }
const _hoisted_39 = { class: "time" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "action" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, "編集", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, "削除", -1))
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("閲覧済み")
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("未閲覧")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "削除しますか？")
], -1))
const _hoisted_53 = { class: "dialog-footer" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("削除")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "削除しますか？")
], -1))
const _hoisted_57 = { class: "dialog-footer" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("削除")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("移動")
const _hoisted_62 = { class: "image-dialog" }
const _hoisted_63 = ["src"]

import { useStore } from "vuex";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faMountain } from '@fortawesome/free-solid-svg-icons'
import { ref, computed, withDefaults, watch, nextTick } from "vue"
import { Question } from "@/types/question"
import { QuestionCategory } from '@/types/question_category'
import QuestionHistory from "@/components/question/QuestionHistory.vue"
import CategoryList from "@/components/common/categories/CategoryList.vue"
import { ElMessage } from 'element-plus'
import { Category } from '@/types/category'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import BlotFormatter from 'quill-blot-formatter'
import ImageCompress from 'quill-image-compress'
import MagicUrl from 'quill-magic-url'
import { QuestionUserView } from "@/types/question_user_view";
import QuestionFiles from "@/components/question/QuestionFiles.vue"

interface Props {
  question: Question | null;
  detailLoading: boolean;
  iineLoading: boolean;
  commentLoading: boolean;
  questionCategories: QuestionCategory[];
  detailLink?: boolean;
  user_views: QuestionUserView[];
}
// const props = defineProps<Props>();
interface Emits {
  (e: "iine", _question_id: number): void;
  (e: "cancelIine", _question_id: number): void;
  (e: "favorite", _question_id: number): void;
  (e: "cancelFavorite", _question_id: number): void;
  (e: "updateQuestion", _question_id: number, _body: string, _answer: string, _files: any[], delete_question_file_ids: number[]): void;
  (e: "moveQuestionCategory", _question_id: number, _move_cateory_id: number): void;
  (e: "deleteQuestion", _question_id: number): void;
  (e: "sendComment", _question_id: number, comment: string): void;
  (e: "updateComment", _comment_id: number, comment: string): void;
  (e: "deleteComment", _question_id: number, _comment_id: number): void;
  (e: "loadViewUsers", _question_id: number): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    question: { type: null, required: true },
    detailLoading: { type: Boolean, required: true },
    iineLoading: { type: Boolean, required: true },
    commentLoading: { type: Boolean, required: true },
    questionCategories: { type: Array, required: true },
    detailLink: { type: Boolean, required: false, default: false },
    user_views: { type: Array, required: true }
  },
  emits: ["iine", "cancelIine", "favorite", "cancelFavorite", "updateQuestion", "moveQuestionCategory", "deleteQuestion", "sendComment", "updateComment", "deleteComment", "loadViewUsers"],
  setup(__props: any, { emit }: { emit: ({
  (e: "iine", _question_id: number): void;
  (e: "cancelIine", _question_id: number): void;
  (e: "favorite", _question_id: number): void;
  (e: "cancelFavorite", _question_id: number): void;
  (e: "updateQuestion", _question_id: number, _body: string, _answer: string, _files: any[], delete_question_file_ids: number[]): void;
  (e: "moveQuestionCategory", _question_id: number, _move_cateory_id: number): void;
  (e: "deleteQuestion", _question_id: number): void;
  (e: "sendComment", _question_id: number, comment: string): void;
  (e: "updateComment", _comment_id: number, comment: string): void;
  (e: "deleteComment", _question_id: number, _comment_id: number): void;
  (e: "loadViewUsers", _question_id: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { question: Question | null, detailLoading: boolean, iineLoading: boolean, commentLoading: boolean, questionCategories: QuestionCategory[], detailLink: boolean, user_views: QuestionUserView[] }
library.add(faEye, faMountain);
const toolber = [
  ['bold', 'italic', 'underline'],
  [{ 'color': [] }, { 'background': [] }],
  ['link'],
  ['image'],
];
const modules = [{
  name: 'blotFormatter',
  module: BlotFormatter,
  options: {/* options */ }
},
{
  name: 'MagicUrl',
  module: MagicUrl,
  options: {/* options */ }
},
{
  name: 'ImageCompress',
  module: ImageCompress,
  options: {
    quality: 0.9,
    maxWidth: 1500,
    maxHeight: 1500,
    imageType: 'image/jpeg',
    debug: false,
    suppressErrorLogging: false, // default
  }
}
]
const quillOptions = {
  debug: 'error'
}

let answerEditor: any = ref(null);





const store = useStore();
let comment = ref("");
let editmode = ref(false);
let formBody = ref("");
let formAnswer = ref("");
let formComment = ref("");
let editCommentId = ref(0);
let detailView = ref(false);

const fileList = ref<File[]>([])
const deleteQuestionFileIds = ref<number[]>([])
// let managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);
let user_id = computed(() => store.state.login.user_id);

const imageDialogVisible = ref(false);
const imageSrc           = ref('');
watch(() => props.question, () => {
  if (editmode.value) {
    editmode.value = false;
  }

  nextTick(() => {
    const imgs:any = document.querySelectorAll('.answer img');
    if (imgs == null) {
      return;
    }
    imgs.forEach((img: any) => {
      img.onclick = (e: any) => {
        imageDialogVisible.value = true;
        imageSrc.value = e.srcElement.currentSrc;
      };
    })

  });
});

const iine = (question_id: number) => {
  emit("iine", question_id);
};
const cancelIine = (question_id: number) => {
  emit("cancelIine", question_id);
};
const favorite = (question_id: number) => {
  emit("favorite", question_id);
};
const cancelFavorite = (question_id: number) => {
  emit("cancelFavorite", question_id);
};
const loadViewUsers = (question_id: number) => {
  emit("loadViewUsers", question_id);
};
const updateQuestion = () => {
  // getHtmlで取得しないと最新の情報が取れない場合がある。(画像の真ん中寄せなど)
  //formAnswerにしたいけど・・
  if (props.question == null) {
    return
  }
  const answer_html = answerEditor.value.getHTML()
  const size = answer_html.length / 1024 / 1024
  // 5MB以上はだめにする
  if (size > 5) {
    ElMessage.error({
      message: '登録するQAのサイズは5MBまでになります',
      dangerouslyUseHTMLString: true,
      showClose: true,
      duration: 0
    });
    return

  }
  emit("updateQuestion", props.question.id, formBody.value, answer_html, fileList.value, deleteQuestionFileIds.value);
  fileList.value = []
  deleteQuestionFileIds.value = []
  editmode.value = false;
};


let moveCategorDialogVisible = ref(false)
let moveCategorId = ref(-1)
const setMoveCategoryId = (category: Category) => {
  moveCategorId.value = category.id;
}
const moveQuestionCategory = () => {
  if (props.question == null) {
    return
  }
  emit("moveQuestionCategory", props.question.id, moveCategorId.value);
  moveCategorDialogVisible.value = false;
}

const sendComment = () => {
  if (props.question == null) {
    return
  }
  emit("sendComment", props.question.id, comment.value);
  comment.value = "";
};
const updateComment = (comment_id: number) => {
  emit("updateComment", comment_id, formComment.value);
};
let deleteCommentId = ref(0);
let deleteConfirmDialogVisible = ref(false);
const deleteComment = () => {
  if (props.question == null) {
    return
  }
  emit("deleteComment", props.question.id, deleteCommentId.value);
  deleteConfirmDialogVisible.value = false;
};
const deleteConfirm = (comment_id: number) => {
  deleteCommentId.value = comment_id;
  deleteConfirmDialogVisible.value = true;
};
let deleteQuestionConfirmDialogVisible = ref(false);
const deleteQuestionConfirm = () => {
  deleteQuestionConfirmDialogVisible.value = true;
};
let deleteQuestion = () => {
  if (props.question == null) {
    return
  }
  emit("deleteQuestion", props.question.id);
  deleteQuestionConfirmDialogVisible.value = false;
};

const edit = () => {
  if (props.question == null) {
    return
  }
  formBody.value = props.question.body;
  // formAnswer.value = props.question.answer;
  answerEditor.value.setHTML(props.question.answer)
  fileList.value = []
  deleteQuestionFileIds.value = []
  editmode.value = true;
};


return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (__props.question != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_3, [
                (__props.question.favorite)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (cancelFavorite(__props.question.id)), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_fa, {
                          icon: ['fas', 'star'],
                          class: "color-yellow favoraite-icon"
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "text",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (favorite(__props.question.id)), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_fa, {
                          icon: ['far', 'star'],
                          class: "color-info favoraite-icon"
                        })
                      ]),
                      _: 1
                    })),
                _createElementVNode("span", {
                  innerHTML: __props.question.body_html
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.categories, (category) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: category.id
                    }, _toDisplayString(category.name) + ">", 1))
                  }), 128)),
                  _createTextVNode(" " + _toDisplayString(__props.question.category_name) + " ", 1),
                  (_unref(managerFlg))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "text",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_isRef(moveCategorDialogVisible) //@ts-ignore
 ? moveCategorDialogVisible.value = true : moveCategorDialogVisible = true; _isRef(moveCategorId) //@ts-ignore
 ? moveCategorId.value = __props.question.question_category_id : moveCategorId = __props.question.question_category_id;})
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createTextVNode(" " + _toDisplayString(__props.question.user_name) + " ", 1),
                _createElementVNode("span", _hoisted_9, "作成日:" + _toDisplayString(__props.question.post_at), 1)
              ]),
              _createElementVNode("div", {
                class: "answer fs14",
                innerHTML: __props.question.answer
              }, null, 8, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.question_files, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "filelist fs12",
                    key: file.id
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("a", {
                        href: file.url,
                        target: "_blank"
                      }, _toDisplayString(file.name), 9, _hoisted_13)
                    ])
                  ]))
                }), 128))
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (__props.question.iine)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "text",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (cancelIine(__props.question.id)), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_16, [
                              _hoisted_17,
                              _createTextVNode(" " + _toDisplayString(__props.question.iine_count), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!__props.question.iine)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "text",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (iine(__props.question.id)), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_18, [
                              _hoisted_19,
                              _createTextVNode(" " + _toDisplayString(__props.question.iine_count), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "light",
                      offset: -5,
                      content: "閲覧UU",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "text",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => {loadViewUsers(__props.question.id); _isRef(detailView) //@ts-ignore
 ? detailView.value = true : detailView = true}, ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_20, [
                              _createVNode(_component_fa, { icon: "eye" }),
                              _createTextVNode(" " + _toDisplayString(__props.question.view_uu), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  (__props.detailLink)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_router_link, {
                          to: { name: 'ProjectQuestion', params: { project_id: _ctx.$route.params.project_id, question_id: __props.question.id } },
                          target: "_blank",
                          class: "button-link"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, { type: "text" }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 512), [
                [_directive_loading, __props.iineLoading]
              ]),
              _createElementVNode("div", _hoisted_23, [
                (__props.question.user_id == _unref(user_id) || _unref(managerFlg))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (edit()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.question.user_id == _unref(user_id) || _unref(managerFlg))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "text",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (deleteQuestionConfirm()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, _unref(editmode) == false]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_26,
              _hoisted_27,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(formBody) ? (formBody).value = $event : formBody = $event)),
                class: "textarea",
                rows: "5"
              }, null, 512), [
                [_vModelText, _unref(formBody)]
              ]),
              _hoisted_28,
              _createVNode(_unref(QuillEditor), {
                ref: (_value, _refs) => {
                  _refs['answerEditor'] = _value
                  _isRef(answerEditor) ? answerEditor.value = _value : answerEditor = _value
                },
                theme: "snow",
                toolbar: toolber,
                globalOptions: quillOptions,
                modules: modules,
                content: _unref(formAnswer),
                "onUpdate:content": _cache[9] || (_cache[9] = ($event: any) => (_isRef(formAnswer) ? (formAnswer).value = $event : formAnswer = $event)),
                contentType: 'html',
                class: "fs14"
              }, null, 8, ["content"]),
              (_unref(editmode))
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createVNode(QuestionFiles, {
                      modelValue: fileList.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((fileList).value = $event)),
                      deleteIds: deleteQuestionFileIds.value,
                      "onUpdate:deleteIds": _cache[11] || (_cache[11] = ($event: any) => ((deleteQuestionFileIds).value = $event)),
                      question_files: __props.question.question_files
                    }, null, 8, ["modelValue", "deleteIds", "question_files"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_isRef(editmode) //@ts-ignore
 ? editmode.value = false : editmode = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  disabled: _unref(formBody).length == 0 || _unref(formAnswer).replace(/<p>|<\/p>|<br>/g, '').length == 0,
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (updateQuestion()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 512), [
              [_vShow, _unref(editmode)]
            ]),
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_el_input, {
                type: "textarea",
                rows: 5,
                modelValue: _unref(comment),
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(comment) ? (comment).value = $event : comment = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_el_button, {
                  disabled: _unref(comment).length == 0,
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (sendComment())),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.question_histories, (his) => {
                return (_openBlock(), _createBlock(_component_el_card, {
                  class: "comment",
                  shadow: "never",
                  key: his.id
                }, {
                  default: _withCtx(() => [
                    (his.h_type == 'comment')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _withDirectives(_createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_38, [
                              _createTextVNode(_toDisplayString(his.user_name) + " ", 1),
                              _createElementVNode("span", _hoisted_39, _toDisplayString(his.post_at), 1)
                            ]),
                            _createElementVNode("div", {
                              innerHTML: his.content_html,
                              class: "fs14"
                            }, null, 8, _hoisted_40),
                            _createElementVNode("div", _hoisted_41, [
                              (his.user_id == _unref(user_id))
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    onClick: ($event: any) => {_isRef(formComment) //@ts-ignore
 ? formComment.value = his.content.comment : formComment = his.content.comment; _isRef(editCommentId) //@ts-ignore
 ? editCommentId.value = his.id : editCommentId = his.id; },
                                    type: "text"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_42
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (his.user_id == _unref(user_id))
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    onClick: ($event: any) => (deleteConfirm(his.id)),
                                    type: "text"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_43
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ], 512), [
                            [_vShow, his.id != _unref(editCommentId)]
                          ]),
                          _withDirectives(_createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(formComment) ? (formComment).value = $event : formComment = $event)),
                              class: "textarea",
                              rows: "5"
                            }, null, 512), [
                              [_vModelText, _unref(formComment)]
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_el_button, {
                                type: "text",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_isRef(editCommentId) //@ts-ignore
 ? editCommentId.value = 0 : editCommentId = 0))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_45
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                disabled: _unref(formComment).length == 0,
                                onClick: ($event: any) => {_isRef(editCommentId) //@ts-ignore
 ? editCommentId.value = 0 : editCommentId = 0; updateComment(his.id); }
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_46
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"])
                            ])
                          ], 512), [
                            [_vShow, his.id == _unref(editCommentId)]
                          ])
                        ]))
                      : (his.h_type == 'update_content')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createVNode(QuestionHistory, { history: his }, null, 8, ["history"])
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ], 512), [
              [_directive_loading, __props.commentLoading]
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.question)
        ? (_openBlock(), _createBlock(_component_el_drawer, {
            key: 1,
            modelValue: _unref(detailView),
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(detailView) ? (detailView).value = $event : detailView = $event)),
            size: '50%',
            "with-header": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, "閲覧履歴(" + _toDisplayString(__props.question.view_pv) + "pv)", 1),
              _withDirectives(_createVNode(_component_el_table, { data: __props.user_views }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "名前"
                  }),
                  _createVNode(_component_el_table_column, { label: "閲覧" }, {
                    default: _withCtx((scope) => [
                      (scope.row.viewed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createVNode(_component_el_tag, { type: "success" }, {
                              default: _withCtx(() => [
                                _hoisted_49
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _createVNode(_component_el_tag, { type: "danger" }, {
                              default: _withCtx(() => [
                                _hoisted_51
                              ]),
                              _: 1
                            })
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]), [
                [_directive_loading, __props.detailLoading]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        title: "削除確認",
        modelValue: _unref(deleteConfirmDialogVisible),
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(deleteConfirmDialogVisible) ? (deleteConfirmDialogVisible).value = $event : deleteConfirmDialogVisible = $event)),
        width: "30%",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_53, [
            _createVNode(_component_el_button, {
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_isRef(deleteConfirmDialogVisible) //@ts-ignore
 ? deleteConfirmDialogVisible.value = false : deleteConfirmDialogVisible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_54
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (deleteComment()))
            }, {
              default: _withCtx(() => [
                _hoisted_55
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_52
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "削除確認",
        modelValue: _unref(deleteQuestionConfirmDialogVisible),
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(deleteQuestionConfirmDialogVisible) ? (deleteQuestionConfirmDialogVisible).value = $event : deleteQuestionConfirmDialogVisible = $event)),
        width: "30%",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_57, [
            _createVNode(_component_el_button, {
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_isRef(deleteQuestionConfirmDialogVisible) //@ts-ignore
 ? deleteQuestionConfirmDialogVisible.value = false : deleteQuestionConfirmDialogVisible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_58
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_unref(deleteQuestion)()))
            }, {
              default: _withCtx(() => [
                _hoisted_59
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_56
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "カテゴリ移動",
        modelValue: _unref(moveCategorDialogVisible),
        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_isRef(moveCategorDialogVisible) ? (moveCategorDialogVisible).value = $event : moveCategorDialogVisible = $event)),
        width: "30%",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_isRef(moveCategorDialogVisible) //@ts-ignore
 ? moveCategorDialogVisible.value = false : moveCategorDialogVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_60
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: _unref(moveCategorId) == __props.question?.question_category_id,
            onClick: _cache[26] || (_cache[26] = ($event: any) => (moveQuestionCategory()))
          }, {
            default: _withCtx(() => [
              _hoisted_61
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createVNode(CategoryList, {
            onListClick: setMoveCategoryId,
            categories: __props.questionCategories,
            hideAll: true
          }, null, 8, ["categories"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 512), [
      [_directive_loading, __props.detailLoading]
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createVNode(_component_el_dialog, {
        modelValue: imageDialogVisible.value,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((imageDialogVisible).value = $event)),
        width: "90%",
        center: "",
        "before-close": () => {imageDialogVisible.value = false},
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", { src: imageSrc.value }, null, 8, _hoisted_63)
        ]),
        _: 1
      }, 8, ["modelValue", "before-close"])
    ])
  ], 64))
}
}

})